
class WebSystem{
	constructor(){
		
	}
	
	static get_resources_prefix(target){
		if(target === 'contents'){
			return '/resources/';
		}
	}
}


function init_web_system(){
	
	var prev = 0;
	var prev_inc = 0;
	
	const header = document.querySelector('#header');
	const headerContents = document.querySelector('#header_contents');
	const preheaderMode = header && header.classList.contains('preHeader_mode');
	
	window.addEventListener('scroll', evt => {
		
		if(  !header || header.classList.contains('noFollow') ){
			return;
		}
		
		const offsetTopContents = header.offsetHeight - headerContents.offsetHeight;//('#header').height() - ('#header_contents').height();
		var inc;
	
		const scrollTop = window.scrollY;//(window).scrollTop();
		
		inc = scrollTop - prev;
		prev = scrollTop;
		
		if( scrollTop > offsetTopContents ){
			header.classList.add('hcontents_fixed', 'under_offset');
			if(preheaderMode){
				header.classList.add('view_logo');
			}
		}else if(preheaderMode || scrollTop < 3){
			header.classList.remove('hcontents_fixed', 'under_offset', 'header_tools_visible', 'view_logo');
		}
		
		if(prev_inc * inc <= 0){
			if(inc > 0){ // Scrolling down
				header.classList.remove('header_tools_visible');
			}else{ // Scrolling up
				header.classList.add('header_tools_visible');
			}
		}
		prev_inc = inc;
		
	});
	
	loading = false;
	// act_url = window.location.pathname+window.location.search;
	if(document.querySelector('#h_logo img')){
		document.querySelector('#h_logo img').addEventListener('click', () => { 
			window.location = '/';
		});
	}
	if(document.querySelector('#header input#menu_locker')){
		document.querySelector('#header input#menu_locker').checked = false;
	}
	
	window.addEventListener('resize', () => {
		window.dispatchEvent(new Event('scroll'));
	});
	
} 


function isLocalDomain(domain){
	
	var extractedDomain = getDomain(domain);
	var localDomain = window.location.host;
	
	return extractedDomain === null || extractedDomain !== localDomain;
	
}

function getDomain(domain){
	
	//find & remove protocol (http, ftp, etc.) and get domain
	if( typeof domain === 'undefined'){
		return null;
	}

	if(domain.indexOf("://") > -1) {
		domain = domain.split('/')[2];
	} else {
		domain = domain.split('/')[0];
	}
	
	//find & remove port number
	domain = domain.split(':')[0];
	
	return (domain.indexOf('.') !== -1) ? domain : null;
	
}


$(() => {
	
	init_web_system();
	
	init_parallax();
	
	window.addEventListener('DOMContentLoaded', (event) => {
		after_load();
		setTimeout(()=>{
			$(window).data('plugin_stellar')._setScrollTop(1);
		}, 850);
	});
	
});


{
	let templateSystem = CsApp3.get('elinkerApps/DefaultWebTemplate');
	
	
	function _scrollTo(offset) {
		
		return new Promise((resolve, reject) => {
			
			$('html').animate(
				{scrollTop: 0}, 
				250, 
				()=>{
					resolve();
				}
			);
		
		});
		return new Promise((resolve, reject) => {
			
			const fixedOffset = offset.toFixed();
			const onScroll = function(){
				if (window.pageYOffset.toFixed() === fixedOffset) {
					window.removeEventListener('scroll', onScroll);
					console.log('SCROLLED!!!');
					resolve();
				}
			}
			
			window.addEventListener('scroll', onScroll);
			onScroll();
			window.scrollTo({
				top: offset,
				behavior: 'smooth'
			});
			
		});
	}
	
	templateSystem.resource('web_system_init', ({appFrame, layer}) => {
		
		document.addEventListener('click', evt => { 
			
			 const axNode = evt.target.closest('a.ax');
			 
			 if(!axNode){
			 	return;
			 }
			
			document.querySelector('#menu_locker').checked = false;
			if(loading){
				console.log('currently loading...');
				return false;
			}
			
			var new_url = axNode.attributes.href ? axNode.attributes.href.value : ''; //this.href; 
			
			
			if ( isLocalDomain(new_url) ) {
				var contents = document.querySelector('#content');
				
				evt.preventDefault();
				var scrollToTopProm = _scrollTo(1);
				/*
				var contentAlreadyLoaded = contents.querySelector('[data-ref="'+new_url+'"]');
				if(showPath(new_url)){
					console.log('contentAlreadyLoaded!!!',contentAlreadyLoaded);
					return;
				}*/
				
				console.log('TO--->new_url',new_url);
				
				//window.scrollTo(0, 0); 
				// window.scrollTo({top: 1, behavior: 'smooth'});
				
				appFrame.load_zone({
					path: new_url,
					component: 'body.Contents',
					autoInit: false,
				}).then( ({layer, init, data}) => {
					console.log('CONTENT:',layer);
					//contents.innerHTML = '';
					
					layer.style.position = 'absolute';
					layer.style.opacity = 0;
					layer.style.zIndex = -1;
					layer.dataset.ref_path = new_url;
					contents.innerHTML = '';
					contents.appendChild(layer);
					
					if( data.extra.params && data.extra.params.page_title && data.extra.params.site_title ){
						
						const newTitle = data.extra.params.page_title +' | '+ data.extra.params.site_title;
						layer.dataset.page_title = newTitle;
						
						
					}
					
					showPath(new_url);
					
					layer.style.position = null;
					layer.style.opacity = null;
					layer.style.zIndex = null;
					
					$(() => {
						
						after_load();
						init();
						scrollToTopProm.then(()=>{
							_scrollTo(0).then(()=>{
								$(window).data('plugin_stellar').refresh();
								$(window).data('plugin_stellar')._setScrollTop(1);
							});
							
						});
						
					});
					
				});
				
			}else{
				
				if( confirm('Se va a cargar la siguiente página externa:\r\n\r\n	- '+
					new_URL+'\r\n\r\nSe abrirá en una nueva ventana, ¿Desea continuar?.') 
				){
					window.open(new_URL, '_blank');
				}
				
				loadingMode(false);
				
			}
		});	
		

	});
	
	function setPath(path, title){
		
		if(title === undefined){
			title = null;
		}
		
		if(path !== window.location.pathname + window.location.search){
			history.pushState(
				{ path: path }, 
				title, 
				path
			);
			
		}else{
			history.replaceState({},
				title//,
				//new_url
			);
		}
		document.title = title;
		
	}
	
	function showPath(path){
		var contents = document.querySelector('#content');
		var content;
		
		for(let node of contents.children){
			if(node.dataset.ref_path !== path){
				node.style.display = 'none';
			}else{
				content = node;
				
			}
		}
		if(!content){
			console.error('content not found...');
			return false;
		}
		content.style.display = null;
		
		setPath(content.dataset.ref_path, content.dataset.page_title);
		
		content.scrollIntoView({ 
			behavior: 'smooth' 
		});
		after_load();
		return true;
		
	}
	
}